import { useMyPresence } from "@liveblocks/react";
import { useAppSelector } from "@store";
import { getCollaborationEntity } from "@store/story/selectors";
import { useEffect, type ReactNode } from "react";

export const ActiveEntityProvider = ({ children }: { children: ReactNode }) => {
  const { newEntityId, newSlideId } = useAppSelector(getCollaborationEntity);
  const [, updateMyPresence] = useMyPresence();

  useEffect(() => {
    try {
      updateMyPresence({
        activeEntityId: newEntityId,
        activeSlideId: newSlideId,
      });
    } catch (error) {
      // A presence write can throw if the room proxy was revoked mid-teardown
      // (see UserPresenceProvider / PreviewPresenceBridge). Swallow — an
      // ephemeral presence ping must not crash the editor.
      console.warn("Failed to update active-entity presence:", error);
    }
  }, [newEntityId, newSlideId, updateMyPresence]);

  return <>{children}</>;
};
